import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useToast } from '@/contexts/ToastContext';
import { fetchWorkerHealth, isWorkerFirebaseReady } from '@/lib/workerApi';

export function useWorkerAction(toastKey: string) {
  const { t } = useTranslation();
  const toast = useToast();

  const ensureReady = useCallback(async (): Promise<boolean> => {
    const health = await fetchWorkerHealth();
    if (health.ok && health.firebaseConfigured && (await isWorkerFirebaseReady())) return true;
    if (health.ok && health.firebaseConfigured) {
      toast.error(t('settings.workerStaleRestart'), toastKey);
      return false;
    }
    toast.error(t('settings.workerRequired'), toastKey);
    return false;
  }, [t, toast, toastKey]);

  return { ensureReady };
}
